<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="mr-2">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3>Profile</h3>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-row no-gutters>
                <v-col cols="12" xl="6" lg="6" md="6">
                    <v-text-field
                        v-model="item.model"
                        hide-details
                        prepend-icon="mdi-hammer-wrench"
                        label="Model *"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="12" xl="6" lg="6" md="6">
                    <v-text-field
                        v-model="item.part"
                        hide-details
                        prepend-icon="mdi-hammer-wrench"
                        label="Part *"
                    >
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" xl="6" lg="6" md="6">
                    <v-text-field
                        v-model="item.reference"
                        hide-details
                        prepend-icon="mdi-barcode"
                        label="Reference *"
                        :rules="[rules.required]"
                        required
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="12" xl="6" lg="6" md="6">
                    <v-text-field
                        v-model="item.k_m"
                        hide-details
                        prepend-icon="mdi-currency-usd"
                        label="K/M"
                        type="number"
                        :rules="[rules.required, rules.number]"
                        required
                    >
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" xl="6" lg="6" md="6">
                    <v-text-field
                        v-model="item.length"
                        hide-details
                        prepend-icon="mdi-currency-usd"
                        label="Length (M) *"
                        type="number"
                        :rules="[rules.required, rules.number]"
                        required
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="12" xl="6" lg="6" md="6">
                    <v-text-field
                        v-model="item.perimeter"
                        hide-details
                        prepend-icon="mdi-currency-usd"
                        label="Perimeter (M)"
                        type="number"
                        :rules="[rules.required, rules.number]"
                        required
                    >
                    </v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                color="primary"
                class="mb-4"
                @click="saveProcess"
                rounded
                :loading="loading"
            >
                SAVE
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import { objDiff } from '@/helpers/objDiff.js'
import API from '@/services/api'

export default {
    name: 'ProfileForm',
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        originalItem: {
            type: Object,
            default: () => ({}),
        },
        createForm: {
            type: Boolean,
            default: () => false,
        },
        setting: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        rules: {
            required: v => !!v || 'required value',
            number: v => v > 0 || 'invalid number',
        },
    }),
    computed: {
        itemDiff: function() {
            if (!this.createForm) {
                return objDiff(this.originalItem, this.item)
            } else {
                return null
            }
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async saveProcess() {
            if (this.createForm) {
                await this.create()
            } else {
                await this.update()
            }
        },
        async create() {
            try {
                this.loading = true
                const item = await API.createProfile({
                    settingId: this.setting.id,
                    ...this.item,
                })
                this.$emit('addItem', item)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async update() {
            try {
                this.loading = true
                const item = await API.updateProfile({
                    settingId: this.setting.id,
                    id: this.item.id,
                    ...this.itemDiff,
                })
                this.$emit('replaceItem', item)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style></style>
